export default __webpack_public_path__ + "cfd3398ae2fd5e6360d4bf3a04146b4e.png";